/**
 * Global Error 模块
 */
import { Module } from 'vuex'
import { RootState } from '../types'
import { ErrorState, ShowErrorPayload } from './types'
import log from '@/utils/log'

enum mutationTypes {
  UPDATE_ERROR_STATE = 'UPDATE_ERROR_STATE',
}

const initialState: ErrorState = {
  isShow: false,
  message: null,
  subMessage: null,
}

export const error: Module<ErrorState, RootState> = {
  namespaced: true,
  state: initialState,
  actions: {
    show({ commit }, payload?: ShowErrorPayload | string): void {
      const errorObject: ErrorState = {
        isShow: true,
        message: null,
        subMessage: null,
      }

      if (payload) {
        const message = typeof payload === 'string' ? payload : payload.message
        errorObject.message = message || null

        if (typeof payload === 'object') {
          errorObject.subMessage = payload.subMessage || null
        }
      }

      // 第三方授权的错误不必上传，只用于阻塞主流程
      if (errorObject.message !== '正在进入第三方授权') {
        log.error({
          content: errorObject.message || '没有错误信息',
          method: 'store.error.show',
          subMessage: errorObject.subMessage,
        })
      }

      commit(mutationTypes.UPDATE_ERROR_STATE, errorObject)
    },
    close({ commit }): void {
      const errorObject: ErrorState = {
        isShow: false,
        message: null,
        subMessage: null,
      }

      commit(mutationTypes.UPDATE_ERROR_STATE, errorObject)
    },
  },
  mutations: {
    [mutationTypes.UPDATE_ERROR_STATE](state, errorObject: ErrorState): void {
      state.isShow = errorObject.isShow
      state.message = errorObject.message
      state.subMessage = errorObject.subMessage
    },
  },
}
